import { DataExtract } from "./models";
import { DataExtractAction } from "./actions";
import { CREATE_DATA_EXTRACT_SUCCESS, LOAD_DATA_EXTRACTS_SUCCESS } from "./actionTypes";

export function reducer(state: DataExtract[] = [], action: DataExtractAction): DataExtract[] {
    switch (action.type) {
        case LOAD_DATA_EXTRACTS_SUCCESS:
            return action.payload;
        case CREATE_DATA_EXTRACT_SUCCESS:
            return [...state, action.payload];
        default:
            return state;
    }
}
